import type { PredictionParameters } from '~/types'

export type ValidationSchema = {
  [key in keyof PredictionParameters]?: (val: Required<PredictionParameters>[key]) => string | true
}

export default {
  // TODO: Add validation schema
  ageAtAccident: (val) => {
    if (val === null)
      return true
    if (val < 0)
      return 'Age needs to be greater than zero'
    return val > 300 ? 'Age needs to be less than 300' : true
  },
} as ValidationSchema
